export const getServiceWorkerUrl = () => {
    if (import.meta.env.DEV) return '/dev-sw.js?dev-sw';

    return `${import.meta.env.BASE_URL}sw.js`.replace(/\/+/g, '/');
};

export const getServiceWorkerIndexUrl = () => {
    return `${import.meta.env.BASE_URL || '/'}index.html`.replace(/\/+/g, '/');
};
